var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.275 9.00005C4.89167 9.00005 4.604 8.82938 4.412 8.48805C4.22067 8.14605 4.225 7.80838 4.425 7.47505L8.15 1.40005C8.35 1.08338 8.63333 0.925049 9 0.925049C9.36667 0.925049 9.65 1.08338 9.85 1.40005L13.575 7.47505C13.775 7.80838 13.779 8.14605 13.587 8.48805C13.3957 8.82938 13.1083 9.00005 12.725 9.00005H5.275ZM14.5 20C13.25 20 12.1873 19.5627 11.312 18.688C10.4373 17.8127 10 16.75 10 15.5C10 14.25 10.4373 13.1874 11.312 12.312C12.1873 11.4374 13.25 11 14.5 11C15.75 11 16.8127 11.4374 17.688 12.312C18.5627 13.1874 19 14.25 19 15.5C19 16.75 18.5627 17.8127 17.688 18.688C16.8127 19.5627 15.75 20 14.5 20ZM1 19.5C0.716667 19.5 0.479333 19.404 0.288 19.212C0.0960001 19.0207 0 18.7834 0 18.5V12.5C0 12.2167 0.0960001 11.979 0.288 11.787C0.479333 11.5957 0.716667 11.5 1 11.5H7C7.28333 11.5 7.521 11.5957 7.713 11.787C7.90433 11.979 8 12.2167 8 12.5V18.5C8 18.7834 7.90433 19.0207 7.713 19.212C7.521 19.404 7.28333 19.5 7 19.5H1Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.54f4e081.svg";
export { ForwardRef as ReactComponent };